import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import "../index.css";
import logo from "../assets/logo.png.png";

function ResetPassword() {
  const { token }       = useParams();
  const navigate        = useNavigate();
  const [password,    setPassword]    = useState("");
  const [confirm,     setConfirm]     = useState("");
  const [loading,     setLoading]     = useState(false);
  const [success,     setSuccess]     = useState(false);
  const [error,       setError]       = useState("");
  const [showPass,    setShowPass]    = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleReset = async () => {
    if (!password)              { setError("Veuillez entrer un nouveau mot de passe"); return; }
    if (password.length < 6)    { setError("Le mot de passe doit contenir au moins 6 caractères"); return; }
    if (password !== confirm)   { setError("Les mots de passe ne correspondent pas"); return; }

    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate("/"), 3000);
      } else {
        const data = await res.json();
        setError(data.error || "Lien invalide ou expiré");
      }
    } catch {
      setError("Erreur serveur");
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* LEFT SIDE */}
        <div className="login-left">
          <div className="company-logo">
            <img src={logo} alt="LOGIMES Logo" />
          </div>
          <h1>Password Reset</h1>
          <p>
            Choisissez un nouveau mot de passe sécurisé pour votre compte LOGIMES.
          </p>
          <span className="footer-text">PFE 2026 – ESEN Manouba</span>
        </div>

        {/* RIGHT SIDE */}
        <div className="login-right" style={{ justifyContent: "center" }}>

          {!success ? (
            <>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ fontSize: "2.5rem" }}></span>
              </div>
              <h2>Nouveau mot de passe</h2>
              <p className="subtitle">
                Entrez votre nouveau mot de passe ci-dessous.
              </p>

              {error && (
                <div style={{
                  background: "#fef0f0", border: "1.5px solid #fcc",
                  color: "#e74c3c", padding: "12px 16px", borderRadius: "10px",
                  fontSize: "0.88rem", fontWeight: 600, marginBottom: "16px"
                }}>
                  ⚠️ {error}
                </div>
              )}

              <div className="form-group">
                <label>Nouveau mot de passe</label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showPass ? "text" : "password"}
                    placeholder="Entrez votre nouveau mot de passe"
                    value={password}
                    onChange={(e) => { setPassword(e.target.value); setError(""); }}
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    onClick={() => setShowPass(!showPass)}
                    style={{
                      position: "absolute", right: "12px", top: "50%",
                      transform: "translateY(-50%)", cursor: "pointer", fontSize: "1.1rem"
                    }}
                  >
                    {showPass ? "🙈" : "👁️"}
                  </span>
                </div>
              </div>

              <div className="form-group">
                <label>Confirmer le mot de passe</label>
                <div style={{ position: "relative" }}>
                  <input
                    type={showConfirm ? "text" : "password"}
                    placeholder="Confirmez votre mot de passe"
                    value={confirm}
                    onChange={(e) => { setConfirm(e.target.value); setError(""); }}
                    onKeyDown={(e) => e.key === "Enter" && handleReset()}
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    onClick={() => setShowConfirm(!showConfirm)}
                    style={{
                      position: "absolute", right: "12px", top: "50%",
                      transform: "translateY(-50%)", cursor: "pointer", fontSize: "1.1rem"
                    }}
                  >
                    {showConfirm ? "🙈" : "👁️"}
                  </span>
                </div>
              </div>

              {/* Force password indicator */}
              {password && (
                <div style={{ marginBottom: "16px" }}>
                  <div style={{ fontSize: "0.75rem", color: "#888", marginBottom: "6px" }}>
                    Force du mot de passe :
                  </div>
                  <div style={{ display: "flex", gap: "4px" }}>
                    {[1, 2, 3, 4].map(i => (
                      <div key={i} style={{
                        flex: 1, height: "4px", borderRadius: "2px",
                        background: password.length >= i * 2
                          ? i <= 1 ? "#e74c3c" : i <= 2 ? "#f39c12" : i <= 3 ? "#3498db" : "#27ae60"
                          : "#e0e0e0"
                      }} />
                    ))}
                  </div>
                </div>
              )}

              <button className="login-btn" onClick={handleReset} disabled={loading}>
                {loading ? "Réinitialisation..." : " RÉINITIALISER LE MOT DE PASSE"}
              </button>

              <Link to="/" className="forgot-under" style={{ textAlign: "center", marginTop: "16px" }}>
                ← Retour à la connexion
              </Link>
            </>
          ) : (
            /* SUCCESS STATE */
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "4rem", marginBottom: "20px" }}>✅</div>
              <h2 style={{ marginBottom: "12px", color: "#1a1a2e" }}>Mot de passe réinitialisé !</h2>
              <p style={{ color: "#888", fontSize: "0.9rem", lineHeight: 1.6, marginBottom: "24px" }}>
                Votre mot de passe a été mis à jour avec succès.<br /><br />
                Vous allez être redirigé vers la page de connexion dans <strong>3 secondes</strong>.
              </p>
              <Link to="/" className="login-btn" style={{
                display: "block", textAlign: "center",
                textDecoration: "none", padding: "13px"
              }}>
                Se connecter maintenant
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;